import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import userReducer from './slices/user/user';
import curriculumReducer from './slices/curriculum/curriculum';
import shoppingReducer from './slices/shopping';
import addressReducer from './slices/user/address';
import studentReducer from './slices/student';

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const shoppingPersistConfig = {
  key: 'shopping',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

// const activityPersistConfig = {
//   key: 'activity',
//   storage,
//   keyPrefix: 'redux-',
//   whitelist: ['sortBy'],
// };

// const customFieldPersistConfig = {
//   key: 'customField',
//   storage,
//   keyPrefix: 'redux-',
//   whitelist: [],
// };

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  product: persistReducer(productPersistConfig, productReducer),
  user: userReducer,
  curriculum: curriculumReducer,
  address: addressReducer,
  shopping: persistReducer(shoppingPersistConfig, shoppingReducer),
  student: studentReducer,
});

export { rootPersistConfig, rootReducer };
